module.exports = __webpack_public_path__ + "img/bean_bg_img.488af9db.jpg";